import { render, staticRenderFns } from "./EventsPage.vue?vue&type=template&id=4bc30554&scoped=true"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"
import style0 from "./EventsPage.vue?vue&type=style&index=0&id=4bc30554&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc30554",
  null
  
)

export default component.exports